<template>
    <transition name="fade">
        <div v-if="!uiState?.mainMenuOpen" class="sign-in-status">
            <span v-if="!userReady" class="text-muted small">Loading...</span>

            <button v-else-if="!user" @click="$emit('open-login')" class="btn btn-sm btn-light text-dark">
                Sign in
            </button>

            <div v-else class="dropdown" ref="dropdownRef">
                <button class="btn btn-sm btn-outline-light dropdown-toggle"
                        type="button"
                        @click="showDropdown = !showDropdown">
                    <span class="d-none d-md-inline">{{ user.user }}</span>
                    <span class="d-inline d-md-none">{{ user.user?.split(' ')[0] }}</span>
                </button>


                <div class="dropdown-menu" v-show="showDropdown">
                    <span class="dropdown-item-text">{{ user.email }}</span>

                    <button class="dropdown-item" @click="goToAccount">
                        My Account
                    </button>
                    <button class="dropdown-item text-danger" @click="logout">Log out</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { useAuthStore } from 'shared-vue'
    import { useRouter, useRoute } from 'vue-router'
    import { computed, onMounted, onBeforeUnmount, watch } from 'vue'
    const route = useRoute();
    const authStore = useAuthStore()
    const router = useRouter()
    const user = computed(() => authStore.user)
    const userReady = computed(() => authStore.userReady)
    import { inject } from 'vue'

    const uiState = inject('uiState')
    import { ref } from 'vue'
    const dropdownRef = ref(null)

    const showDropdown = ref(false)
    const logout = () => {
        authStore.logout()
        router.replace({ path: route.path, query: {} });
    }


    const handleClickOutside = (e) => {
        if (dropdownRef != null && dropdownRef.value && !dropdownRef.value.contains(e.target)) {
            showDropdown.value = false
        }
    }

    onMounted(() => {
        document.addEventListener('click', handleClickOutside)
    })

    onBeforeUnmount(() => {
        document.removeEventListener('click', handleClickOutside)
    })

    const goToAccount = () => {
        showDropdown.value = false
        router.push({ name: 'MyAccount' }) // make sure your route is named 'MyAccount'
    }

    watch(
        () => route.query.token,
        async (newToken) => {
            if (newToken) {
                const refreshToken = route.query.refreshtoken

                if (refreshToken) {
                    localStorage.setItem('refreshtoken', refreshToken)
                    console.log('refreshtoken Token Stored!')
                }

                localStorage.setItem('jwt', newToken)
                console.log('JWT Token Stored!')

                // Remove token from URL
                router.replace({ path: route.path, query: {} })

                // Fetch user
                await authStore.fetchUser()
            }
        },
        { immediate: true }
    )

</script>

<style scoped>
    .sign-in-status {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .dropdown {
        position: relative;
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        right: 0;
        z-index: 1000;
        background-color: white;
        border: 1px solid #ccc;
        padding: 0.5rem;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.2s ease;
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
    .dropdown-menu {
        display: block; /* required for v-show to apply */
        min-width: 180px;
    }
</style>
